// extracted by mini-css-extract-plugin
export default {"root":"popular-plans-module--root--bae38"};